import React from 'react';
import { connect } from 'react-redux';

import NewMessage from './new-message';
import MessageHistory from './message-history';

import styles from './ChatMessages.css';

const mapStateToProps = state => {
  return { receiver: state.receiver, user: state.user, theme: state.user.theme };
};

const ConnectedChatMessages = (props) => {
  let ChatMessagesThemeColor = styles.chatMessagesLightColor;
  if (props.theme === 'DARK') {
    ChatMessagesThemeColor = styles.chatMessagesDarkColor;
  }
  return <div className={[styles.mainContainer, ChatMessagesThemeColor].join(' ')}>
    <MessageHistory props={props} />
    <NewMessage props={props} />
  </div>
}

const ChatMessages = connect(mapStateToProps)(ConnectedChatMessages);

export default ChatMessages;


// WEBPACK FOOTER //
// ./src/pages/chat/chat-messages/ChatMessages.jsx